import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import InsuranceDocumentStepperContainer from '../../../stepper/components/InsuranceDocumentStepperContainer';
import { useDocumentId, useQueryWithSimpleErrorHandling, useToast, useAuthUserData } from 'hooks';
import { DOCUMENT_HEADER_QUERY } from 'features/insuranceDocument/queries/insuranceDocumentQueries';
import { DOCUMENT_UPDATED } from '../subscriptions';
import { useSubscription } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { generationInProgressStatusVar } from 'features/insuranceDocument/variables';

const InsuranceDocumentPageContainer = ({ contextRef }) => {
  const [documentHeaderData, setDocumentHeaderData] = useState(null);
  const [error, setError] = useState(null);
  const { documentId } = useDocumentId();
  const { t } = useTranslation();
  const addToast = useToast();
  const { authUser } = useAuthUserData();

  const { loading: documentHeaderDataLoading } = useQueryWithSimpleErrorHandling(DOCUMENT_HEADER_QUERY, {
    variables: { documentId },
    skip: !documentId,
    onCompleted: data => {
      setError(null);
      setDocumentHeaderData(data?.documentHeader);
      generationInProgressStatusVar(data?.documentHeader?.generationInProgress);
    },
    onError: error => {
      const statusCode = error.graphQLErrors?.[0]?.extensions?.response?.status;
      setError({ statusCode });
    }
  });

  useSubscription(DOCUMENT_UPDATED, {
    variables: { documentId, userId: parseInt(authUser?.userId) },
    skip: !documentId || !parseInt(authUser?.userId),
    onData: data => {
      if (data) addToast(t('Offer.Edit.ModifiedData'), 'info', { toastId: 'documentUpdatedToast', autoClose: false }, null, true);
    }
  });

  const documentNotFound = useMemo(() => error?.statusCode === 404, [error]);
  const documentNotLoaded = documentId && !documentHeaderData;
  if (documentHeaderDataLoading || documentNotLoaded || documentNotFound) return <></>;

  return (
    <InsuranceDocumentStepperContainer
      contextRef={contextRef}
      documentHeaderData={documentHeaderData ?? {}}
      setDocumentHeaderData={setDocumentHeaderData}
    />
  );
};

InsuranceDocumentPageContainer.propTypes = {
  contextRef: PropTypes.shape({
    current: PropTypes.shape({
      properties: PropTypes.object.isRequired,
      events: PropTypes.shape({
        onChangeDocumentStateFailed: PropTypes.array.isRequired,
        onDocumentStateUpdated: PropTypes.func.isRequired
      }),
      functions: PropTypes.object.isRequired
    })
  })
};

export default InsuranceDocumentPageContainer;
